<template>
  <div>
    <div class="operaBox padding-lr-sm padding-bottom-lg">
      <SecondTitle :secTitle="secTitle"></SecondTitle>
      <div
        class="operation flex align-center justify-around padding-tb-xs"
        style="padding-top: 10px"
      >
        <!--		  <div class="text-xss text-white">运营中城市</div>-->
        <div
          class="text-xss text-green flex flex-direction align-center"
          style="position: relative"
        >
          <span class="yunying-text">{{ activeUsers }}</span>
          <img
            class="operation-icon"
            src="../../assets/images/index/opraHaveIcon.png"
          />
          活跃用户数
        </div>
        <div
          class="text-xss text-green flex flex-direction align-center"
          style="position: relative"
        >
          <span class="yunying-text">{{ activeVehicles }}</span>
          <img
            class="operation-icon"
            src="../../assets/images/index/opraHaveIcon.png"
          />
          活跃车辆数
        </div>
      </div>
      <div class="operation flex align-center justify-around padding-tb-xs">
        <!--		  <div class="text-xss text-white">运营中通道</div>-->
        <div
          class="text-xss text-green flex flex-direction align-center"
          style="position: relative"
        >
          <span class="yunying-text">{{ userStickiness }}</span>
          <img
            class="operation-icon"
            src="../../assets/images/index/opraHaveIcon.png"
          />
          本月新增入网司机
        </div>
        <div
          class="text-xss text-green flex flex-direction align-center"
          style="position: relative"
        >
          <span class="yunying-text">{{ vehicleStickiness }}</span>
          <img
            class="operation-icon"
            src="../../assets/images/index/opraHaveIcon.png"
          />
          本月新增车辆数
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SecondTitle from "../secondTitle.vue";
import { dataInterface } from "@/api/dataInterfaceApi";

export default {
  data() {
    return {
      operData: {},
      secTitle: {
        title: "运营趋势",
      },
      passNum: [],
      operPassNum: "",
      alloperPassNum: "",
      operCityNum: "",
      alloperCityNum: "",

      activeUsers: "", // 活跃用户数
      activeVehicles: "", // 活跃车辆数
      userStickiness: "", // 用户粘性
      vehicleStickiness: "", // 车辆粘性
    };
  },
  components: {
    SecondTitle,
  },
  watch: {},
  mounted() {},
  methods: {
    getData(data) {
      //   this.getPassNum(data);
      this.getOperationLayout(data);
      this.yonghuzhibiao(data);
	  this.getCarTarget(data)
    },
    // getPassNum(data={}){
    // 		let params = {};
    // 		// this.operPassNum='';
    // 		// this.operCityNum='';

    // 			if(data){
    // 				//省市区
    // 				this.yunyingbujuAll({
    // 					"enCode":"TiDB-quanguo-yunyingbuju"//全国
    // 				},false)
    // 				this.yunyingbuju({
    // 					"enCode":"TiDB-shengshiqu-yunyingbuju",
    //     			"@province":data.province||data.city||data.district
    // 				},true);
    //
    // 			}else {
    // 				this.yunyingbuju({
    // 					"enCode":"TiDB-quanguo-yunyingbuju"//全国
    // 				},false)
    // 			}
    // },
    // 获取运营布局四个数据
    getOperationLayout(data) {
      this.activeUsers = "";
      this.activeVehicles = "";
      //   this.userStickiness = "";
    //   this.vehicleStickiness = "";
      // let ADCODE= data?data.province||data.city||data.district:'000000';
      const { query } = this.$route;
      if (query.token) localStorage.setItem("uid", query.token);
      let params = {
        enCode: "hdz-yyqs",
        "@province": data.province || data.city || data.district || "000000",
        "@uid": localStorage.getItem("uid") || "000000",
      };
      dataInterface
        .dataFaceApiXZ(params)
        .then((res) => {
          console.log(res, "hdz-yyqs");
          if (!res) return;
          res = res[0];
          this.activeUsers = res.hyyh;
          this.activeVehicles = res.hycl;
          //   this.userStickiness = res.yhnx;
        //   this.vehicleStickiness = res.clnx;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    yunyingbuju(params, flag) {
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          // 1是运营中，0是建设中
          this.passNum = res;
          this.passNum.map((item) => {
            if (item.operate_status == 1) {
              //运营中
              if (flag) {
                this.operPassNum = item.PpssNum;
                this.operCityNum = item.cityNum;
                return;
              }
              this.alloperPassNum = item.PpssNum;
              this.operPassNum = item.PpssNum;

              this.operCityNum = item.cityNum;
              this.alloperCityNum = item.cityNum;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    yunyingbujuAll(params) {
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          // 1是运营中，0是建设中
          this.passNum = res;
          this.passNum.map((item) => {
            if (item.operate_status == 1) {
              //运营中
              this.alloperPassNum = item.PpssNum;
              this.alloperCityNum = item.cityNum;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    yonghuzhibiao(data = {}) {
      let _this = this;
      const { query } = this.$route;
      if (query.token) localStorage.setItem("uid", query.token);
      let params = {
        enCode: "hdz-yhzb",
        "@province": data.province || data.city || data.district || "000000",
        "@uid": localStorage.getItem("uid") || "000000",
      };
      dataInterface
        .dataFaceApiXZ(params)
        .then((res) => {
          console.log(res, "hdz-yhzb");
          if (!res) return;
          res = res[0];
          this.userStickiness = res.byxzrwsj || 0;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCarTarget(data = {}) {
      let _this = this;
      const { query } = this.$route;
      if (query.token) localStorage.setItem("uid", query.token);
      let params = {
        enCode: "hdz-clzb",
        "@province": data.province || data.city || data.district || "000000",
        "@uid": localStorage.getItem("uid") || "000000",
      };
      dataInterface
        .dataFaceApiXZ(params)
        .then((res) => {
          if (!res) return;
          res = res[0];
		console.log(res,'本月新增车辆数')
		  this.vehicleStickiness = res.byxzcl
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.operaBox {
  width: 438px;
  min-height: 343px;
  border-radius: 10px;
  background: linear-gradient(
    180deg,
    rgba(47, 164, 159, 0.11) 0%,
    rgba(1, 177, 169, 0.06) 79%,
    rgba(53, 149, 147, 0.11) 100%
  );
}
.operation-icon {
  width: 82px;
  height: 72px;
}
.operaBox {
  background: rgba(19, 29, 35, 0.6);
}

.yunying-text {
  color: #ffffff;
  // color: red;
  position: absolute;
  top: 0px;
  // width: 40px;
  // height: 40px;
  // background: red;
}
</style>